import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
    const { user, isAuthenticated } = useAuth();

    if (isAuthenticated === null || user === null) return null;
    if (!user?.is_admin) return <Navigate to="/main" replace />;
    return children;
};

export default AdminRoute;
